<template>
  <div
    v-if="viewAsMode"
    :class="[
      theme.isDark.value ? 'bg-amber-900/40 border-amber-700/60 text-amber-200' : 'bg-amber-100 border-amber-300 text-amber-900',
      'border-b px-6 py-2.5 text-sm flex items-center gap-3'
    ]"
  >
    <svg class="w-4 h-4 shrink-0" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"/><path stroke-linecap="round" stroke-linejoin="round" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"/></svg>
    <div class="flex-1">
      <span class="font-semibold">Preview mode:</span>
      viewing as <span class="font-semibold">{{ viewAsLabel }}</span>
      — write actions hidden
    </div>
    <a
      :href="dashboardWithoutViewAs"
      :class="[theme.isDark.value ? 'text-amber-200 hover:text-amber-100' : 'text-amber-900 hover:text-amber-700', 'underline text-xs']"
    >Exit preview</a>
  </div>
</template>

<script setup lang="ts">
import { inject } from 'vue'
import { useTheme } from '../../utils/useTheme'
import { useViewAs } from '../../utils/useViewAs'

const theme = inject('theme', useTheme())
const { viewAsMode, viewAsLabel, dashboardWithoutViewAs } = useViewAs()
</script>
